export default "__VITE_ASSET__24e0204b__"